import { createFileRoute } from '@tanstack/react-router'
import { CrosspostingPlaces } from '~/features/crossposting/components/crossposting-places'

export const Route = createFileRoute('/dashboard/crossposting/')({
  component: CrosspostingPlaces,
})
